import React from "react";
import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";
import { formikWrapperBag } from "../formikBags/formikWrapperBag";

interface FormikWrapperProps<
  T extends Record<string, any> | Record<string, any>[]
> {
  data: T;
  children: (
    formikProps: FormikHelpers<T> & {
      values: T;
      handleBlur: (e: React.FocusEvent<any>) => void;
      handleKeyDown: (e: React.KeyboardEvent<any>) => void;
    }
  ) => React.ReactNode;
  customInitialValues?: Record<string, any>;
  onSubmitHandler?: (
    values: T,
    formikHelpers: FormikHelpers<T>
  ) => Promise<void>;
  validationSchema?: Yup.ObjectSchema<any> | null;
}

export const ReusableFormikWrapper = <
  T extends Record<string, any> | Record<string, any>[]
>({
  data,
  children,
  onSubmitHandler,
  customInitialValues = {},
  validationSchema,
}: FormikWrapperProps<T>) => {
  const { initialValues, handleCustomBlur, handleKeyDown } = formikWrapperBag(
    data,
    customInitialValues
  );

  return (
    <Formik<T>
      initialValues={initialValues as T}
      validationSchema={validationSchema}
      onSubmit={onSubmitHandler || (() => {})}
    >
      {(formikProps) => {
        const { handleSubmit, dirty, isSubmitting } = formikProps;

        const handleBlur = (e: React.FocusEvent<any>) => {
          formikProps.handleBlur(e);
          handleCustomBlur(
            e,
            handleSubmit,
            dirty,
            isSubmitting,
            formikProps.setSubmitting
          );
        };

        return (
          <Form className="flex flex-col w-full min-w-0 space-y-4 h-full">
            {children({
              ...formikProps,
              handleBlur,
              handleKeyDown: (e) =>
                handleKeyDown(
                  e,
                  handleSubmit,
                  dirty,
                  isSubmitting,
                  formikProps.setSubmitting
                ),
            })}
          </Form>
        );
      }}
    </Formik>
  );
};

export default ReusableFormikWrapper;
